module.exports = __webpack_public_path__ + "sunsemweb/img/cz2.805a02ca.png";